import Colors from '../../Support/Theme/Colors/Colors'
import { Theme, createStyles } from '@material-ui/core'
import { BORAL_GREEN, BORAL_DARK_GREY, BORAL_YELLOW } from '../../Constants/Theme/Theme.constants'

const OrderProgressStyles = (theme: Theme) => {
  const dot = {
    borderRadius: theme.spacing(1) * 2,
    width: theme.spacing(1) * 2,
    height: theme.spacing(1) * 2,
    display: 'inline-block',
    marginRight: theme.spacing(1) * 0.5,
  } as any
  return createStyles({
    circularProgress: {
      color: theme.palette.grey[`500`],
      position: `absolute`,
      top: 4,
      left: 0,
    },
    deliveryTotalContainer: {
      position: `relative`,
      marginBottom: theme.spacing(1) * 5,
    },
    deliveryTotalContent: {
      position: `absolute`,
    },
    etaBoxSm: {
      position: `relative`,
    },
    etaBoxXsm: {
      borderTop: `${theme.palette.grey[`300`]} solid 1px`,
      marginTop: theme.spacing(1) * 3,
      paddingBottom: theme.spacing(1) * 3,
      paddingTop: theme.spacing(1) * 3,
    },
    nextEtaTime: {
      opacity: 0.5,
    },
    boxHeading: {
      color: theme.palette.grey[500],
    },

    timerIcon: {
      opacity: 0.1,
      width: 18,
      position: `absolute`,
      top: -1,
      left: -2,
    },

    timerTicking: {
      width: 16,
      position: `absolute`,
      top: 5,
    },
    timerContainer: {
      width: 18,
      position: `relative`,
      top: 4,
    },
    plusLoadDot: {
      backgroundColor: Colors.raven[500],
      ...dot,
    },
    plusLoadDotSubmittedOrApplied: {
      backgroundColor: Colors.raven[500],
    },
    arrivedDot: {
      backgroundColor: BORAL_GREEN,
      ...dot,
    },
    inTransitDot: {
      backgroundColor: BORAL_YELLOW,
      ...dot,
    },
    toGoDot: {
      backgroundColor: Colors.raven[200],
      ...dot,
    },
    dotCopy: {
      color: theme.palette.grey[500],
      textAlign: `left`,
      display: 'flex',
      alignItems: 'center',
    },
    callBoral: {
      color: BORAL_DARK_GREY,
      textDecoration: `underline`,
      cursor: `pointer`,
    },
    graphItem: {
      position: `relative`,
      maxWidth: '300px',
      maxHeight: '300px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    pieChartTitle: {
      color: theme.palette.grey[500],
    },
    detailsItemIcon: {
      marginLeft: -theme.spacing(1) * 0.5,
    },
    lineheight16: {
      lineHeight: `16px`,
    },
    qtyText: {
      lineHeight: 1.2,
      marginTop: theme.spacing(1) * 0.75,
    },
  })
}

export default OrderProgressStyles
